import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c(VTooltip,{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c(VIcon,_vm._g({class:'no-available-seats ' + _vm.additionalClass},on),[_vm._v("warning")])]}}],null,false,1497803428)},[_c('span',[_vm._v(_vm._s(this.$t("global.not_available_seats")))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }